var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfilArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M9.955,1.881a2,2,0,0,1,3.091,0l7.269,8.849A2,2,0,0,1,18.769,14H4.231a2,2,0,0,1-1.545-3.269Z",
    transform: "translate(0 23) rotate(-90)",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfilArrow);
export default __webpack_public_path__ + "static/media/icon_profil_arrow.3adfb4f0.svg";
export { ForwardRef as ReactComponent };